<template>
    <v-container>
        <v-row>
            <v-col class="text-right">
                <router-link :to="{ name: 'AddExperiment' }">
                    <v-btn color="success">
                        <v-icon>mdi-plus</v-icon>
                        Add experiment
                    </v-btn>
                </router-link>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Select experiments group to view details
                    </v-card-title>
                    <v-card-subtitle>
                        Search existing experiments groups
                    </v-card-subtitle>
                    <v-card-text>
                        <GroupsAutocomplete/>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import GroupsAutocomplete from '@/components/GroupsAutocomplete';

    export default {
        name: 'GroupSelector',
        components: {
            GroupsAutocomplete
        }
    }
</script>

